import React, { useMemo, useState } from 'react';
import {
	CaseType,
	CaseTypeType,
	useWorkplaceRootCaseTypesQuery,
	useWorkplacesQuery,
	WorkplaceCaseType,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import MonitoringCenterNewRequestsItem from './MonitoringCenterNewRequestsItem';
// @ts-ignore
import styles from './MonitoringCenterNewRequests.module.scss';
import MonitoringCenterNewRequestsFilter, {
	MonitoringCenterNewRequestsFilterValues,
} from './MonitoringCenterNewRequestsFilter';
import MonitoringCenterNewRequestsItemDetail from './MonitoringCenterNewRequestsItemDetail';

const MonitoringCenterNewRequests: React.FC = () => {
	const [selectedCaseType, setSelectedCaseType] = useState<CaseType>();
	const [filter, setFilter] =
		useState<MonitoringCenterNewRequestsFilterValues>();

	const userWorkplaces = useWorkplacesQuery();

	const workplaceIds = useMemo(() => {
		const tempIds: string[] = [];
		userWorkplaces?.data?.workplaces?.data?.forEach(item => {
			if (item?.id) {
				tempIds.push(item.id);
			}
		});
		return tempIds;
	}, [userWorkplaces]);

	const caseTypes = useWorkplaceRootCaseTypesQuery({
		workplaceIds: workplaceIds,
		caseTypeTypes: [CaseTypeType.CaseType, CaseTypeType.Folder],
	});

	const groupedCaseTypes = useMemo(() => {
		const tempCaseTypes: WorkplaceCaseType[] = [];
		caseTypes?.data?.workplaceCaseTypes?.data?.forEach(item => {
			if (
				item &&
				!tempCaseTypes.some(
					subItem => subItem?.caseType?.code === item?.caseType?.code,
				)
			) {
				tempCaseTypes.push(item);
			}
		});
		return tempCaseTypes;
	}, [caseTypes]);

	if (caseTypes.isLoading || userWorkplaces.isLoading) {
		return <Loading />;
	}

	const handleChangeFilter = (
		filter: MonitoringCenterNewRequestsFilterValues,
	) => {
		setFilter(filter);
	};

	const handleOpenDetail = (caseType: CaseType) => {
		setSelectedCaseType(caseType);
	};

	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<MonitoringCenterNewRequestsFilter onFilter={handleChangeFilter} />
			{selectedCaseType ? (
				<MonitoringCenterNewRequestsItemDetail
					caseType={selectedCaseType}
					onBack={() => setSelectedCaseType(undefined)}
				/>
			) : (
				<div className={styles.wrapper}>
					{groupedCaseTypes.map((item, index) => {
						if (item?.caseType) {
							return (
								<React.Fragment key={index}>
									<MonitoringCenterNewRequestsItem
										filter={filter}
										caseType={item.caseType}
										onShowMore={handleOpenDetail}
										style={{ overflow: 'initial' }}
									/>
								</React.Fragment>
							);
						}
					})}
				</div>
			)}
		</div>
	);
};

export default MonitoringCenterNewRequests;
